import { Button } from "@/components/ui/button";
import logo from "@/assets/logowhite.png";
const Hero = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
      });
    }
  };
  return (
    <section className="relative h-screen min-h-[600px] flex items-start md:items-center pt-28 md:pt-0">
      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />

      {/* Content */}
      <div className="container relative z-8 mx-auto px-4 pb-8 md:pb-0">
        <div className="max-w-3xl mx-auto text-white animate-fade-in-up text-center">
          {/* Logo */}
          <div className="mb-6 md:mb-8 flex justify-center">
            <img src={logo} alt="Mangimi Rubini Magione - Logo negozio dal 1983" className="h-24 md:h-32 w-auto drop-shadow-lg" />
          </div>

          {/* Headline */}
          <h1 className="mb-4 md:mb-6 drop-shadow-lg uppercase text-2xl md:text-3xl lg:text-4xl" style={{ fontFamily: 'Verdana, sans-serif' }}>
            Dal 1983 ci prendiamo cura del tuo giardino e dei tuoi animali, sia da allevamento che domestici
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl mb-6 md:mb-8 text-white/90 leading-relaxed" style={{ fontFamily: 'Verdana, sans-serif' }}>
            Presso la nostra sede di Magione troverai tutto ciò di cui hai bisogno per la cura dei tuoi animali, del tuo giardino e dei tuoi allevamenti.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => scrollToSection("prodotti")}
              size="lg"
              className="btn-cta rounded-full px-8 py-6 text-base font-semibold uppercase"
              style={{ fontFamily: 'Verdana, sans-serif' }}
            >
              Scopri i nostri prodotti
            </Button>
            <Button
              onClick={() => scrollToSection("contatti")}
              size="lg"
              className="btn-secondary rounded-full px-8 py-6 text-base font-semibold uppercase"
              style={{ fontFamily: 'Verdana, sans-serif' }}
            >
              Vieni a trovarci
            </Button>
          </div>

          {/* Scroll Down Arrow - Mobile Only */}
          <div className="md:hidden mt-16 flex justify-center animate-bounce">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Hero;
